import { useEffect } from "react";

const usePreventImageDownload = () => {
	useEffect(() => {
		// Check if document is defined
		if (typeof document !== "undefined") {
			const preventDownload = (e) => {
				e.preventDefault();
				e.stopPropagation();
			};

			const images = document.querySelectorAll("img:not(.clickable)"); // this will select only images that do not have the 'clickable' class

			images.forEach((img) => {
				img.style.webkitUserSelect = "none";
				img.style.webkitTouchCallout = "none";
				img.addEventListener("contextmenu", preventDownload);
				img.addEventListener("dragstart", preventDownload);
				img.addEventListener("pointerdown", preventDownload);
				img.addEventListener("touchend", preventDownload);
			});

			return () => {
				images.forEach((img) => {
					img.removeEventListener("contextmenu", preventDownload);
					img.removeEventListener("dragstart", preventDownload);
					img.removeEventListener("pointerdown", preventDownload);
					img.removeEventListener("touchend", preventDownload);
				});
			};
		}
	}, []);
};

export default usePreventImageDownload;
